<template>
	<window-view title="Kunde" v-on="$listeners" :width="900" :actions="_actions">
		<tabs-view :tabs="_tabs" v-model="tab" style="margin-top: -10px;" />

		<panel-view v-if="tab == 'details'">
			<panel-sep-view>
				<grid-view :cols="['1fr', '1fr', '1fr']">
					<input-view v-model="m.name" label="Navn *" />
					<input-view v-model="m.vat" label="CVR" />
					<input-view v-model="m.ean" label="EAN" />
				</grid-view>
			</panel-sep-view>
			<panel-sep-view>
				<grid-view :cols="['1fr']">
					<input-view v-model="m.address" label="Adresse" />
				</grid-view>
				<grid-view :cols="['1fr', '2fr']">
					<input-view v-model="m.zip" label="Postnr" />
					<input-view v-model="m.city" label="By" />
				</grid-view>
			</panel-sep-view>
			<panel-sep-view>
				<grid-view :cols="['1fr', '1fr', '1fr']">
					<input-view v-model="m.phone" label="Telefon" />
					<input-view v-model="m.email" label="E-mail" />
					<input-view v-model="m.att" label="Kontaktperson" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
		<panel-view v-if="tab == 'managers'">
			<panel-sep-view>
				<grid-view :cols="['1fr']">
					<inline-table-view v-model="m._embedded.managers" :columns.sync="managers.cols" :blank="managers.manager.model()">
						<template v-slot:name="{ item }">
							<input type="text" v-model="item.name">
						</template>
						<template v-slot:phone="{ item }">
							<input type="text" v-model="item.phone">
						</template>
						<template v-slot:email="{ item }">
							<input type="text" v-model="item.email">
						</template>
						<template v-slot:password="{ item }">
							<input type="text" v-model="item.password">
						</template>
					</inline-table-view>
				</grid-view>
			</panel-sep-view>
		</panel-view>
		<panel-view v-if="tab == 'prices'">
			<panel-sep-view>
				<grid-view :cols="['1fr']">
					<inline-table-view v-model="m._embedded.prices" :columns.sync="prices.cols" :blank="prices.price.model()">
						<template v-slot:sku="{ item }">
							<input type="text" v-model="item.sku">
						</template>
						<template v-slot:type="{ item }">
							<inline-select-view v-model="item.type" :options="prices.price.types()" />
						</template>
						<template v-slot:amount="{ item }">
							<input type="text" v-model="item.amount">
						</template>
						<template v-slot:qty="{ item }">
							<input type="text" v-model="item.qty">
						</template>
						<template v-slot:cover="{ item }">
							<inline-select-view v-model="item.cover" :options="prices.price.covers()" />
						</template>
					</inline-table-view>
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import customer from '../../../model/customer';
	import manager from '../../../model/manager';
	import price from '../../../model/price';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				tab: 			'details',
				m: 				customer.model(),
				managers: {
					manager:	manager,
					cols: [
						{
								label:	'Navn *',
								name:	'name'
						},
						{
								label:	'Telefon *',
								name:	'phone'
						},
						{
								label:	'E-mail *',
								name:	'email',
								weight: '2fr'
						},
						{
								label:	'Adgangskode',
								name:	'password'
						}
					]
				},
				prices: {
					price:		price,
					cols: [
						{
								label:	'Varenr *',
								name:	'sku'
						},
						{
								label:	'Type *',
								name:	'type'
						},
						{
								label:	'Dækker *',
								name:	'cover'
						},
						{
								label:	'Fra antal *',
								name:	'qty',
								align:	'right'
						},
						{
								label:	'Sats *',
								name:	'amount',
								align:	'right'
						}
					]
				}
			};
		},
		watch: {
			'm._embedded.managers': {
				handler(n) {
					console.log('managers', n);
				},
				deep: true
			}
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			},
			_tabs() {
				return [
					{
						label: 'Detaljer',
						value: 'details'
					},
					{
						label: 'Byggeledere',
						value: 'managers'
					},
					{
						label: 'Priser',
						value: 'prices'
					}
				];
			}
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};
		}
	}
</script>

<style lang="scss" scoped>

</style>